import React from 'react';

const LoadingIcon = () => (
    <div className="lds-container">
        <div className="lds-ring"><div /><div /><div /><div /></div>
    </div>
);

export default LoadingIcon;